import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {
  typesPath: () => '/api/CorrectiveActions/Types',
  correctiveActionTypeRestorePath: (id) => `/api/CorrectiveActions/Types/${id}/restore`,
  typePathById: (id) => `/api/CorrectiveActions/Types/${id}`,
  typeGridPath: (params) => `/api/CorrectiveActions/Types/Grid/${getQueryParams(params)}`,
  typeAuditsPathById: (id, params) => `/api/CorrectiveActions/Types/${id}/Audits${getQueryParams(params)}`,
  typeAuditPropertiesPathById: (id) => `/api/CorrectiveActions/Types/${id}/Audits/Properties`,
  typeAuditUsersPathById: (id) => `/api/CorrectiveActions/Types/${id}/Audits/Users`,
	// subjects
  subjectsPath: () => '/api/CorrectiveActions/Subjects',
	subjectsGridPath: (params) => `/api/CorrectiveActions/Subjects/Grid${getQueryParams(params)}`,
	subjectPathById: (id) => `/api/CorrectiveActions/Subjects/${id}`,
	subjectRestorePathById: (id) => `/api/CorrectiveActions/Subjects/${id}/restore`,
  subjectAuditsPathById: (id, params) => `/api/CorrectiveActions/Subjects/${id}/Audits${getQueryParams(params)}`,
  subjectAuditPropertiesPathById: (id) => `/api/CorrectiveActions/Subjects/${id}/Audits/Properties`,
  subjectAuditUsersPathById: (id) => `/api/CorrectiveActions/Subjects/${id}/Audits/Users`,
};

export const getCorrectiveActionTypes = () => makeRequest(authFetch.get(routes.typesPath()));

export const getCorrectiveActionTypesGrid = (params) => makeRequest(authFetch.get(routes.typeGridPath(params)));

export const postCorrectiveActionType = (data) => makeRequest(authFetch.put(routes.typesPath(), data));

export const deleteCorrectiveActionTypeById = (id) => makeRequest(authFetch.delete(routes.typePathById(id)));

export const restoreCorrectiveActionType = (id) =>
  makeRequest(authFetch.patch(routes.correctiveActionTypeRestorePath(id)));

export const getCorrectiveActionTypeAudits = (id, params) =>
  makeRequest(authFetch.get(routes.typeAuditsPathById(id, params)));
export const getCorrectiveActionTypeAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.typeAuditPropertiesPathById(id)));
export const getCorrectiveActionTypeAuditUsers = (id) => makeRequest(authFetch.get(routes.typeAuditUsersPathById(id)));

// Corrective Action Subjects

export const getCorrectiveActionSubjects = () =>
  authFetch.get(routes.subjectsPath()).catch((error) => {
    console.error(error);
    throw error;
  });

export const getCorrectiveActionSubjectsGrid = (params) => makeRequest(
	authFetch.get(routes.subjectsGridPath(params)),
);

export const saveCorrectiveActionSubject = (data) => makeRequest(
	authFetch.put(routes.subjectsPath(), data),
);

export const deleteCorrectiveActionSubjectById = (id) => makeRequest(
	authFetch.delete(routes.subjectPathById(id)),
)

export const restoreCorrectiveActionSubjectById = (id) => makeRequest(
	authFetch.patch(routes.subjectRestorePathById(id)),
);

export const getCorrectiveActionSubjectAudits = (id, params) => makeRequest(
	authFetch.get(routes.subjectAuditsPathById(id, params)),
);

export const getCorrectiveActionSubjectAuditProperties = (id) => makeRequest(
	authFetch.get(routes.subjectAuditPropertiesPathById(id)),
);

export const getCorrectiveActionSubjectAuditUsers = (id) => makeRequest(
	authFetch.get(routes.subjectAuditUsersPathById(id)),
);
